/**
 * Helpers for the weight editor (§8.6). Relative effects are entered as a percentage and
 * stored as a log coefficient; absolute effects are entered and stored in EUR/unit.
 */

/** +4.5 % → ln(1.045) = 0.044017 */
export function pctToLog(pct: number): number {
  return Math.log(1 + pct / 100)
}

/** 0.044017 → 4.5 (%) */
export function logToPct(value: number): number {
  return (Math.exp(value) - 1) * 100
}
